import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { BlobConfig } from '../blob-messaging/blob/BlobConfig';
import { BlobKey } from '../blob-messaging/blob/BlobKey';
import { getColorTheme } from '../blob-messaging/blob/blobUtils';
import { getSentryExtra } from '../error/getSentryExtra';
import { LOG } from '../http/HttpRequester';
import { StyledVideoComponent } from '../blob-messaging/blob/Blob.styles';
import { useLayoutTemplate } from '../hooks/useLayoutTemplate';
export const Animation = ({
  imageUrl,
  colorThemeOption,
  loop = false,
  renderBlob = false
}) => {
  const video = useRef(null);
  const blobConfig = BlobConfig[BlobKey.AnimationBlob];
  const {
    configColorThemeOption
  } = blobConfig;
  const colorTheme = colorThemeOption || configColorThemeOption;
  const {
    innerBlobColor
  } = getColorTheme(colorTheme);
  const {
    shouldUseLayoutTemplate
  } = useLayoutTemplate();
  useEffect(() => {
    const timeout = setTimeout(() => {
      if (video.current) {
        const playPromise = video.current.play();

        if (playPromise !== undefined) {
          playPromise.catch(error => LOG.error('Error playing animation', {
            extra: getSentryExtra(error)
          }));
        }
      }
    }, 500);
    return () => {
      clearTimeout(timeout);
    };
  }, [video]);
  return /*#__PURE__*/_jsx(StyledVideoComponent, {
    id: 'message-animation',
    innerBlobColor: innerBlobColor,
    loop: loop,
    muted: true,
    preload: "auto",
    ref: video,
    renderBlob: renderBlob,
    role: "video",
    shouldUseLayoutTemplate: shouldUseLayoutTemplate,
    children: /*#__PURE__*/_jsx("source", {
      src: imageUrl,
      type: "video/webm"
    })
  });
};